import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CrmComponent } from './crm.component';
import { CrmDetailsComponent } from './details/crm-details.component';

const routes: Routes = [
  {
    path: 'details/client/:clientId',
    component: CrmDetailsComponent
  },
  {
    path: 'details/:networkId',
    component: CrmDetailsComponent
  },
  {
    path: 'lcdata/:networkId',
    redirectTo: 'details/:networkId',
    pathMatch: 'full'
  },
  {
    path: '',
    component: CrmComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CrmRoutingModule { }
